import { render, staticRenderFns } from "./PriorityDropdown.vue?vue&type=template&id=11145e73&scoped=true&"
import script from "./PriorityDropdown.vue?vue&type=script&lang=js&"
export * from "./PriorityDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PriorityDropdown.vue?vue&type=style&index=0&id=11145e73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11145e73",
  null
  
)

export default component.exports